var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"no-uppercase white--text",attrs:{"dark":"","color":"buttonPrimary","elevation":"0"},on:{"click":_vm.triggerClick}},on),[_vm._v("Apply filter")])]}}])},[_c('span',[_vm._v("Press to apply filtering")])])}
var staticRenderFns = []

export { render, staticRenderFns }